import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/_config/config';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DataService } from '../_service/data.service';
import { ExcelService } from '../_service/excel.service';
import { environment } from 'src/environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import __ from 'underscore';
import { FilterBaseComponent } from '../_base/filter-base.component';
import { HttpClient } from "@angular/common/http";

import { ThrowStmt } from '@angular/compiler';
import  *  as  column  from  './columnList.json';
declare const Highcharts: any;
declare const $: any;
declare const moment: any;

@Component({
  selector: 'app-lead-type',
  templateUrl: './lead-type.component.html',
  styleUrls: ['./lead-type.component.scss']
})
export class LeadTypeComponent extends FilterBaseComponent implements OnInit {
  public config:any = new Config();
  public filterForm:FormGroup;
  public regionQualification:any = [];
  public outletQualification: any=[];
  public zoneQualification:any = [];
  public topModel:any = [];
  public imageUrl:string = environment.imageUrl;
  totalLeads:any = { total:0, qualified:0, sales:0, new:0 };
  loginData: any;
  firstTimeRun: Boolean = true;
  columnName: any;

  constructor(
  private http: HttpClient,
  private fb: FormBuilder,
  protected dataService: DataService,
  private ExcelService: ExcelService
) {
  super(dataService);

  this.filterForm = this.fb.group({
    zone: [""],
    region: [""],
    parent_group: [""],
    outlet: [""],
start_date: [""],
end_date: [""],
    userType: [""],
  });

}

  ngOnInit() {
    this.loginData = (this.dataService.getCookies('loginData'))? JSON.parse(this.dataService.getCookies('loginData')).acl : JSON.parse(localStorage.getItem('loginData')).acl;
    if(this.loginData.userType === 6) { // TSM/RO
        this.parentStatus = true;
        this.getAllParent('aa');
    } else if(this.loginData.userType === 8) { // Zonal
        this.regionStatus = true;
        this.parentStatus = true;
        this.getAllRegion('aa');
    } else if(this.loginData.userType === 1) { // Agency or HO
        this.regionStatus = true;
        this.parentStatus = true;
        this.zoneStatus = true;
        this.channelStatus = true;
        this.getAllZone();
    } else if(this.loginData.userType === 9){
        this.parentStatus = true;
        this.outletStatus = true;
        this.channelStatus = true;
        this.getAllChannel("''");
    } else if(this.loginData.userType === 10) { // Zonal manager
        this.regionStatus = true;
        this.parentStatus = true;
        // this.zoneStatus = true;
        this.channelStatus = true;
        this.getAllRegion('aa');
    }  else {
        this.regionStatus = true;
        this.outletStatus = true;
        this.channelStatus = true;
        this.getAllRegion("''");
    }

    
    this.filterForm.patchValue({
        "userType": this.loginData.userType
    })
    this.initializeDateRangePicker(); 
    
    this.zoneSetting();
    this.regionSetting();
    this.parentSetting();
    this.outletSetting();
    this.columnSetting();
    this.channelSetting();
    this.outletTypeSetting();
  }

   get isFilterApplied(): boolean {
  return (
    this.selectedZone.length > 0 ||
    this.selectedRegion.length > 0 ||
    this.selectedParent.length > 0 ||
    this.selectedOutlet.length > 0 ||
    this.selectedChannel.length > 0 ||
    this.selectedOutletType.length > 0 ||
    !this.isDefaultDateRange()
  );
}

public advanceFilter(){
  if(this.firstTimeRun) {
      this.apiReq = {
          zone:'',
          region:'',
          parent: '',
          outlet: '',
          channel:'',
          outletType: '',
          agl_flag: '',
      }
  }
  // this.sourceChart('ww')
  this.getTotalCount();
  this.getNonSalesCount();
  this.getSalesLeadsData();
  // this.getLeadRegionCount();
  // this.getLeadOutletCount();
  // this.getLeadZoneCount();
  // this.getTopModelCount();
  // this.getLeadHistory();
  this.columnList = column['default'];
  // this.getAllColumn('hyperlocal_lead_report')
  this.firstTimeRun = false;
}

download() {
  if (this.selectedColumn.length === 0) {
      this.dataService.showError('Please select column name.');
  } else {
      this.dataService.startLoader();

  let finalData = {
      one: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
      columnList: this.selectedColumn
  }
  this.dataService.post('leadType/downloadLeadType', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
        //  console.log('download data', res['data']);
         if (res['data'].length) {
            this.ExcelService.exportAsExcelFile(res['data'], 'lead_type_report');
            } else {
                this.dataService.showError('No Data Found.')
            }      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}
}

public getTotalCount(){
  this.dataService.startLoader();
  let finalData = {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date
  }
  this.dataService.post('leadType/leadTypeCount', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.totalLeads = res['data'];
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public nonSalesChart(leadType) {
    Highcharts.chart('non_sales_lead', {
        chart: {
            type: 'bar',
            height: 380
        },
        exporting: { enabled: false },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories:[''],
            title: {
                text: null
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
                align: 'high'
            },
            labels: {
                overflow: 'justify'
            }
        },
        tooltip: {
            valueSuffix: ''
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true
                }
            }
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            x: 10,
            y: -10,
            floating: false,
            borderWidth: 1,
            backgroundColor:
                Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
            shadow: true
        },
        credits: {
            enabled: false
        },
        series: leadType
    });
}
public getNonSalesCount(){

    this.dataService.startLoader();
    let finalData = {
        zone: this.apiReq.zone,
        region: this.apiReq.region,
        parent: this.apiReq.parent,
        outlet: this.apiReq.outlet,
        channel: this.channelName,
        start_date: this.filterForm.value.start_date,
        end_date: this.filterForm.value.end_date
    }
    this.dataService.post('leadType/nonSalesLeads', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
            this.nonSalesChart(res['data']);
        }
        else{
            this.dataService.showError(res['message']);
            if(res['code'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
    })
}

public salesLeadsChart(info) {
    // console.log(info)
    Highcharts.chart('sales_lead', {
      chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
      },
      exporting: { enabled: false },
      title: {
          text: ''
      },
      subtitle: {
          text: ''
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.y}</b>'
      },
      accessibility: {
          point: {
              valueSuffix: '%'
          }
      },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                  enabled: true,
                  format: '<b>{point.name}</b>: {point.y}'
              }
          }
      },
      series: [{
          name: '',
          colorByPoint: true,
          data: info
      }]
  });
  }
  
  getSalesLeadsData() {
    this.dataService.startLoader();
    let finalData = {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date
  }
      this.dataService.post('leadType/salesLeads', finalData).subscribe(res=>{
          this.dataService.stopLoader();
          if(res['code'] == 200){
            this.salesLeadsChart(res['data'])
            // this.leadResponseChart(res['data'][0])
          }
          else{
              this.dataService.showError(res['message']);
              if(res['code'] == 401){
                  this.dataService.logout();
              }
          }
      }, err=>{
          this.dataService.stopLoader();
          this.dataService.showError(err['message']);
      })
  }

  public clearFilter() {
    this.dataService.removeCookies("hyperLocalFilter", "");
   this.selectedZone = [];
    this.selectedRegion = [];
    this.selectedParent = [];
    this.selectedChannel = [];
    this.selectedOutlet = [];
    this.selectedOutletType = [];

    window.location.reload();
  }

}
